import { render, staticRenderFns } from "./BaseInfoPanel.vue?vue&type=template&id=de7fa300&scoped=true&"
var script = {}
import style0 from "./BaseInfoPanel.vue?vue&type=style&index=0&id=de7fa300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de7fa300",
  null
  
)

export default component.exports